// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2{
  text-align: center;
}

h1{
  text-align: center;
}

form {
  text-align: center;
}

.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.user-account h2 {
  display: block;
  text-align: center;
  margin-bottom: 20px;
  
}

.user-account label {
  display: block;
  text-align: left;
  margin-bottom: 5px;
}

.user-account input {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.savebutton {
    margin: .5em;
    padding: .25em;
    border: none;
}

.savebutton:hover {
  background-color: #98c2f0;
}

.contact-options label {
  display: block;
  text-align: left;
  margin-bottom: 5px;
}

.settingswitcher {
  justify-self: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/account.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["h2{\n  text-align: center;\n}\n\nh1{\n  text-align: center;\n}\n\nform {\n  text-align: center;\n}\n\n.flex-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.user-account h2 {\n  display: block;\n  text-align: center;\n  margin-bottom: 20px;\n  \n}\n\n.user-account label {\n  display: block;\n  text-align: left;\n  margin-bottom: 5px;\n}\n\n.user-account input {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n\n.savebutton {\n    margin: .5em;\n    padding: .25em;\n    border: none;\n}\n\n.savebutton:hover {\n  background-color: #98c2f0;\n}\n\n.contact-options label {\n  display: block;\n  text-align: left;\n  margin-bottom: 5px;\n}\n\n.settingswitcher {\n  justify-self: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
